import { PlayerApi } from '../../communication/player-api/PlayerApi'
import {myPlayer} from '../../MyPlayer'
import {ApplicationState, getStore} from '../Store'
import {ReduxAction, hasExpired, createAction} from '../ReduxUtils'
import {UserTransaction, UserTransactionQueryResult} from '../../communication/PlayerApiProtocol.generated'

export const REQUEST_TRANSACTIONS = 'REQUEST_TRANSACTIONS'
export const RECEIVE_TRANSACTIONS = 'RECEIVE_TRANSACTIONS'
export const TRANSACTIONS_ERROR = 'TRANSACTIONS_ERROR'

export const fetchTransactions = (forced? : boolean, page? : number, type? : string, currency? : string) =>
	getStore().dispatch(_fetchTransactions(forced, page, type, currency) as any)

function _fetchTransactions(force? : boolean, page? : number, type? : string, currency? : string) {
	return (dispatch, getState : () => ApplicationState) => {
		if (!hasExpired(force, getState().player.transactionState, 60)){
			return
		}

		dispatch(requestTransactions())

		PlayerApi.requestTransactions(myPlayer.id, page, type, currency, (tqr : UserTransactionQueryResult)=>{
			dispatch(receiveTransactions(tqr.transactions))
		},()=>{
			dispatch(transactionsError())
		})
	}
}

function transactionsError() : ReduxAction<{}> {
	return createAction(TRANSACTIONS_ERROR, {})
}

function requestTransactions() : ReduxAction<{}> {
	return createAction(REQUEST_TRANSACTIONS, {})
}

export function receiveTransactions(transactions : UserTransaction[]) : ReduxAction<UserTransaction[]> {
	return createAction(RECEIVE_TRANSACTIONS, transactions)
}
